module.exports = "../images-welovealmaty/pattern5.png";